import { ApiError, WipStatusSubmitModel, WorkshopService } from 'api-new/generated';
import { useMutation, UseMutationOptions } from 'react-query';

export const useUpdateWipStatusMutation = (
  options?: Omit<
    UseMutationOptions<number, ApiError, { id: number; requestBody: WipStatusSubmitModel }, unknown>,
    'mutationFn'
  >
) =>
  useMutation(
    ({ id, requestBody }: { id: number; requestBody: WipStatusSubmitModel }) =>
      WorkshopService.postWorkshopWipStatus(id, requestBody),
    options
  );
